// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b44075b7","455":"9183c1bd"}[chunkId] + ".chunk.js";
};